var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasContent)?_c('div',{staticClass:"guarantee-print-block",style:({ fontSize: _vm.fontSize })},[_c('div',{staticClass:"guarantee-content",domProps:{"innerHTML":_vm._s(_vm.guaranteeHtml)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }